var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 764,
    height: 260,
    viewBox: "0 0 764 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.67 259.61H0V239.61H264.67C298.42 239.61 325.88 212.15 325.88 178.4V105.13C325.88 47.1602 373.05 -0.00976562 431.02 -0.00976562C488.99 -0.00976562 536.16 47.1602 536.16 105.13C536.16 136.2 561.44 161.48 592.51 161.48H764V181.48H592.51C550.41 181.48 516.16 147.23 516.16 105.13C516.16 58.1802 477.97 19.9902 431.02 19.9902C384.07 19.9902 345.88 58.1802 345.88 105.13V178.4C345.88 223.18 309.45 259.61 264.67 259.61Z",
    fill: "url(#paint0_linear_485_190)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.82 259.11C195.067 259.11 199.32 254.857 199.32 249.61C199.32 244.363 195.067 240.11 189.82 240.11C184.573 240.11 180.32 244.363 180.32 249.61C180.32 254.857 184.573 259.11 189.82 259.11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M500.18 49.1602C505.427 49.1602 509.68 44.9069 509.68 39.6602C509.68 34.4135 505.427 30.1602 500.18 30.1602C494.933 30.1602 490.68 34.4135 490.68 39.6602C490.68 44.9069 494.933 49.1602 500.18 49.1602Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_485_190",
    x1: 0,
    y1: 129.81,
    x2: 764,
    y2: 129.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B82F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#98B0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E1E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLine);
export default __webpack_public_path__ + "static/media/right_line.f3c9349bf6701e3e7172b7c685b892a9.svg";
export { ForwardRef as ReactComponent };